import React from 'react';
import {Col, Row} from 'react-bootstrap';
import logoCleanbill from '../../common/assets/img/logo-cleanbill-blanc.png';

const LogoHeader = () => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={{span: 6, offset: 3}} lg={{span: 4, offset: 4}} className="cleanbill-login-col">
          <img src={logoCleanbill} className="cleanbill-white-logo" alt="logo"/>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default LogoHeader;
